import React from 'react';
import { Link } from "react-router-dom";
import * as ROUTES from '../routes/routes';
import logo from '../assets/images/logo.png';
import logo_change from '../assets/images/logo.svg';




class Headercanterlogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <>
                <header className="header header-center-logo">
                    <div className="header-wrapper">
                        <Link to={ROUTES.HOME} title="" className="site-logo">
                            <img src={logo_change} className="img-fluid" alt="" />
                        </Link>
                    </div>
                </header>
            </>
        );
    }
};

export default Headercanterlogo;